export default __webpack_public_path__ + "static/media/guide0207_m.74ae11c9.jpg";